import { render, staticRenderFns } from "./BrandGoods.vue?vue&type=template&id=2332ff67"
import script from "./BrandGoods.vue?vue&type=script&lang=js"
export * from "./BrandGoods.vue?vue&type=script&lang=js"
import style0 from "./BrandGoods.vue?vue&type=style&index=0&id=2332ff67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports